export default class {
    constructor ($translate, ModalService, CourseVersionResource) {
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.CourseVersionResource = CourseVersionResource;
    }

    deleteImage (training) {
        const message = this.$translate.instant('course.Are you sure you want to delete the image?');
        this.ModalService.confirm(message, 'small').then(() => {
            this.CourseVersionResource.deleteTrainingImage({ id: training.id }).$promise.then(() => {
                training.imageFilename = null;
            });
        });
    }

    setImage ($file, form) {
        form.file = $file;
    }

    setScorm ($file, form) {
        if ($file.size) {
            form.scormFileName = $file.name;
            form.scormFile = $file;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/course/version/trainingForm/file/index.js